import { render, staticRenderFns } from "./conversionName.vue?vue&type=template&id=c460647c&scoped=true"
import script from "./conversionName.vue?vue&type=script&lang=js"
export * from "./conversionName.vue?vue&type=script&lang=js"
import style0 from "./conversionName.vue?vue&type=style&index=0&id=c460647c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c460647c",
  null
  
)

export default component.exports